class MobileNavToggle extends HTMLElement {
	constructor() {
		super()
		this.menuDrawer = document.querySelector('.f-drawer-mobile-nav')
		this.addEventListener('click', this.openNav.bind(this))

		if (this.menuDrawer) {
			this.menuDrawer.addEventListener('close', () => {
				this.setAttribute('aria-expanded', 'false')
			})
		}
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.openNav.bind(this))
	}

	openNav() {
		if (this.menuDrawer) {
			this.menuDrawer.openDrawer()
			this.setAttribute('aria-expanded', 'true')
		}
	}
}
customElements.define('mobile-nav-toggle', MobileNavToggle)

class MobileNavSubmenus {
	constructor(container) {
		this.container = container
		this.drawer = container.closest('.f-drawer-mobile-nav')
		this.mainPanel = container.querySelector('.f-mobile-nav__main-panel')
		this.mainScrollContainer = container.querySelector('.f-mobile-nav__inner')
		this.submenuTriggers = container.querySelectorAll('.f-mobile-nav__submenu-trigger')
		this.submenuPanels = container.querySelectorAll('.f-mobile-nav__submenu-panel')
		this.backBtns = container.querySelectorAll('.f-mobile-nav__back-btn')
		this.scrollContainers = [
			this.drawer,
			this.drawer?.querySelector('.f-drawer__content'),
			this.drawer?.querySelector('.scroll-container'),
			this.container,
			this.mainPanel,
			this.mainScrollContainer,
			...this.submenuPanels,
			...this.container.querySelectorAll('.f-mobile-nav__submenu-content'),
		].filter(Boolean)
		this.activeSubmenu = null
		
		this.bindEvents()
		this.bindDrawerEvents()
	}

	bindEvents() {
		// Handle submenu triggers
		this.submenuTriggers.forEach(trigger => {
			trigger.addEventListener('click', (e) => {
				e.preventDefault()
				const submenuId = trigger.dataset.submenu
				this.openSubmenu(submenuId)
			})
		})

		// Handle back buttons
		this.backBtns.forEach(btn => {
			btn.addEventListener('click', () => {
				this.closeSubmenu()
			})
		})

		// Handle submenu close buttons
		const submenuCloseBtns = this.container.querySelectorAll('.f-mobile-nav__submenu-header .f-drawer__close')
		submenuCloseBtns.forEach(btn => {
			btn.addEventListener('click', () => {
				if (this.drawer && this.drawer.closeDrawer) {
					this.drawer.closeDrawer()
				}
			})
		})
	}

	bindDrawerEvents() {
		if (!this.drawer) return

		this.drawer.addEventListener('open', () => {
			this.resetForOpen()
		})
		this.drawer.addEventListener('close', () => {
			this.resetScrollPositions()
		})
	}

	openSubmenu(submenuId) {
		const targetPanel = this.container.querySelector(`[data-panel="${submenuId}"]`)
		if (!targetPanel) return

		// Hide all other submenu panels
		this.submenuPanels.forEach(panel => {
			panel.removeAttribute('data-active')
			panel.setAttribute('hidden', '')
		})

		// Show target submenu panel
		targetPanel.removeAttribute('hidden')
		setTimeout(() => {
			targetPanel.setAttribute('data-active', '')
		}, 10)

		// Slide main panel out
		this.mainPanel.setAttribute('data-submenu-open', '')
		
		this.activeSubmenu = submenuId
	}

	closeSubmenu() {
		// Hide active submenu panel
		if (this.activeSubmenu) {
			const activePanel = this.container.querySelector(`[data-panel="${this.activeSubmenu}"]`)
			if (activePanel) {
				activePanel.removeAttribute('data-active')
				setTimeout(() => {
					activePanel.setAttribute('hidden', '')
				}, 300)
			}
		}

		// Slide main panel back in
		this.mainPanel.removeAttribute('data-submenu-open')
		
		this.activeSubmenu = null
	}

	resetScrollPositions() {
		this.scrollContainers.forEach(scrollContainer => {
			scrollContainer.scrollTop = 0
		})
	}

	resetForOpen() {
		this.resetScrollPositions()
		requestAnimationFrame(() => {
			this.resetScrollPositions()
		})
	}
}

// Initialize submenu functionality when mobile nav exists
document.addEventListener('DOMContentLoaded', () => {
	const mobileNav = document.getElementById('Mobile-Nav')
	if (mobileNav) {
		mobileNav.submenuInstance = new MobileNavSubmenus(mobileNav)
	}
})
